module.exports = __webpack_public_path__ + "static/media/oneday_4.150c0e24.png";